<template>
  <i-button
    type="text"
    :class="`table-control table-control--${type}`"
    :disabled="disabled"
    v-on="$listeners"
  />
</template>

<script>
  export default {
    props: {
      type: {
        type: String,
        default: 'default'
      },

      disabled: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  .table-control {
    background-repeat: no-repeat;
    background-position: center;
    width: 24px;
    height: 24px;
    display: inline-block;

    @each $type in $table-controls {
      &--#{$type} {
        background-image: url('/img/icons/table-controls/#{$type}.svg');
      }
    }

    &[disabled] {
      opacity: 0.5;
    }
  }
</style>
